<template>
  <div id="app">
<!--    <img src="./assets/logo.png">-->
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      // tabUrl: ''
    }
  },
  created() {
    this.refreshPage()
  },
  mounted () {
    //获取屏幕尺寸
    const that = this
    // if (sessionStorage.getItem('tabUrl')) {
    //   this.tabUrl = sessionStorage.getItem('tabUrl')
    // }
    window.addEventListener('resize', function () {
      that.refreshPage()
    })
  },
  methods: {
    refreshPage() {
      const cw = document.documentElement.clientWidth
      const url = this.$route.path
      if (cw > 1023) {
        // this.$router.push({path: '/'});
        if (url === '/indexApp') {
          this.goTab('/')
        } else if (url === '/solutionApp') {
          this.goTab('/solution')
        } else if (url === '/cooperationApp') {
          this.goTab('/cooperation')
        }
        // else if (url === '/instituteApp') {
        //   this.goTab('/institute')
        // }
        else if (url === '/aboutApp') {
          this.goTab('/about')
        } else if (url === '/sysIntroApp') {
          this.goTab('/sysIntro')
        } else if (url === '/instituteApp') {
          this.goTab('/aboutInfo')
        }
      } else {
        if (url === '/') {
          this.goTab('/indexApp')
        } else if (url === '/solution') {
          this.goTab('/solutionApp')
        } else if (url === '/cooperation') {
          this.goTab('/cooperationApp')
        }
        // else if (url === '/institute') {
        //   this.goTab('/instituteApp')
        // }
        else if (url === '/about') {
          this.goTab('/aboutApp')
        } else if (url === '/sysIntro') {
          this.goTab('/sysIntroApp')
        } else if (url === '/aboutInfo') {
          this.goTab('/instituteApp')
        }
      }
    },
    goTab(url) {
      sessionStorage.setItem('tabUrl', url)
      this.$router.push(url);
    },
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue